"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./HeaderSection.scss");
const React = __importStar(require("react"));
const images_1 = require("./images");
const HeaderSection = () => {
    return (React.createElement("header", { className: "header-section sui-w-full" },
        React.createElement("div", { className: "sui-mb-3" },
            React.createElement("div", { className: "sui-flex sui-flex-wrap sui-justify-between sui-mb-2.5" },
                React.createElement(images_1.JrNba, null),
                React.createElement(images_1.FcBarcelona, null),
                React.createElement(images_1.MlbProgram, null)),
            React.createElement("div", { className: "sui-flex sui-flex-wrap sui-justify-between" },
                React.createElement(images_1.MlsWordmark, null),
                React.createElement(images_1.AocVolleyball, null),
                React.createElement(images_1.HockeyCoachVision, null),
                React.createElement(images_1.PplPlay, null))),
        React.createElement("div", { className: "sui-mb-2" },
            React.createElement("p", { className: "sui-heading-md sui-text-gray-10" }, "Train like the pros \u2014 powered by TeamSnap+"))));
};
exports.default = HeaderSection;
